
const HOUR_IN_MS = 60*60*1000
const TASK_COOKIE_NAME = 'uxm-aff7be3040edfb9e8bf7a44b589a7c9794f6ef57'
const TASK_CONTEXT_COOKIE_NAME = 'uxm-80f8bd35f6d032b00479e43190bc0aab9416cb06'

export const getTask = () => {
	try {
		const name = TASK_COOKIE_NAME + '='
		const decodedCookie = decodeURIComponent(document.cookie)
		const ca = decodedCookie.split(';')
		let content = ''
		for(let i = 0; i <ca.length; i++) {
			let c = ca[i]
			while (c.charAt(0) == ' ')
				c = c.substring(1)
			if (c.indexOf(name) == 0)
				content = c.substring(name.length, c.length)
		}
		
		if (!content)
			return null
		else
			return JSON.parse(content)
	} catch(err) {
		console.error(`ERROR - Failed to get task from cookie. Details: ${err.stack||err.message}`)
		return null
	}
}

export const setTask = (task, deleteOn) => {
	try {
		const time = deleteOn ? (-HOUR_IN_MS) : HOUR_IN_MS
		const date = new Date()
		date.setTime(date.getTime() + time)
		const expires = '; expires=' + date.toUTCString()
		document.cookie = TASK_COOKIE_NAME + '=' + JSON.stringify(task)  + expires + '; path=/'
	} catch(err) {
		console.error(`ERROR - Failed to set task using cookie. Details: ${err.stack||err.message}`)
	}
}

export const getContext = () => {
	try {
		const name = TASK_CONTEXT_COOKIE_NAME + '='
		const decodedCookie = decodeURIComponent(document.cookie)
		const ca = decodedCookie.split(';')
		let content = ''
		for(let i = 0; i <ca.length; i++) {
			let c = ca[i]
			while (c.charAt(0) == ' ')
				c = c.substring(1)
			if (c.indexOf(name) == 0)
				content = c.substring(name.length, c.length)
		}
		
		if (!content)
			return {}
		else
			return JSON.parse(content)
	} catch(err) {
		console.error(`ERROR - Failed to get task context from cookie. Details: ${err.stack||err.message}`)
		return {}
	}
}

export const setContext = context => {
	try {
		const date = new Date()
		date.setTime(date.getTime() + HOUR_IN_MS)
		const expires = '; expires=' + date.toUTCString()
		document.cookie = TASK_CONTEXT_COOKIE_NAME + '=' + JSON.stringify(context||{})  + expires + '; path=/'
	} catch(err) {
		console.error(`ERROR - Failed to set task context using cookie. Details: ${err.stack||err.message}`)
	}
}

export const setDebug = debug => {
	try {
		const context = getContext() || {}
		context.debug = debug
		setContext(context)
	} catch (err) {
		console.error(`ERROR - Failed to set debug mode in the task context. Details: ${err.stack||err.message}`)
	}
}

export const getDebug = () => {
	try {
		const context = getContext() || {}
		return context.debug ? true :  false
	} catch (err) {
		console.error(`ERROR - Failed to get debug mode from the task context. Details: ${err.stack||err.message}`)
	}
}

export const cancelTask = () => {
	try {
		setTask({}, true)
	} catch (err) {
		console.error(`ERROR - Failed to cancel task. Details: ${err.stack||err.message}`)
	}
}

export const markAsCompleted = (id, next, context) => {
	const { debug } = context || {}

	const goToNext = () => {
		if (debug)
			console.log('INFO - Moving to tracking the next instruction in the stack')
		if (next && typeof(next) == 'function')
			next()
	}
	try {

		if (debug)
			console.log(`INFO - Marking instruction ID ${id} as completed...`)
		if (!id) {
			goToNext()
			return
		}

		const { code, completionCriteria } = getTask()||{}
		const completionCriterion = (completionCriteria||[]).find(x => x && x.id == id)
		if (completionCriterion) {
			if (debug)
				console.log(`INFO - Instruction ID ${id} found`)
			if (!completionCriterion.completed) {
				completionCriterion.completed = true
				completionCriterion.completion_date = Date.now()
				setTask({ code, completionCriteria })
				if (debug)
					console.log(`INFO - Instruction ID ${id} successfully marked as completed`)
				goToNext()
			} else if (debug)
				console.log(`WARN - Instruction ID ${id} was already marked as completed`)
		} else {
			if (debug)
				console.log(`WARN - Instruction ID ${id} not found`)
			goToNext()
		}
	} catch (err) {
		console.error(`ERROR - Failed to mark task instruction as completed. Details: ${err.stack||err.message}`)
		try {
			goToNext()
		} catch(error) {
			console.error(`ERROR - Failed to mark task instruction as completed. Details: ${error.stack||error.message}`)
		}
	}
}




